/**
 * HTML-escape a backend-sourced value before interpolating it into an
 * iframe/document.write() HTML template (queue-print sheet, TOKEN-UPDATE/T2).
 * Mirrors the module-local helper in printToken.js:65 — same replacement set
 * (`& < > " ' /`) — extracted here so new print surfaces don't duplicate it.
 */
export function escapeHtml(value) {
  if (value === null || value === undefined) return '';
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
    .replace(/\//g, '&#x2F;');
}
